import { render, staticRenderFns } from "./languageAchievement.vue?vue&type=template&id=e87c5c08&"
import script from "./languageAchievement.vue?vue&type=script&lang=js&"
export * from "./languageAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports